interface ChallengeTabNavigationProps {
  activeTab: 'leaderboard' | 'rules' | 'feed';
  onTabChange: (tab: 'leaderboard' | 'rules' | 'feed') => void;
}

export function ChallengeTabNavigation({ activeTab, onTabChange }: ChallengeTabNavigationProps) {
  const tabs = [
    { id: 'leaderboard' as const, label: 'Leaderboard', icon: 'leaderboard' },
    { id: 'rules' as const, label: 'Rules', icon: 'rule_folder' },
    { id: 'feed' as const, label: 'Feed', icon: 'forum' },
  ];

  return (
    <div className="pt-6 pb-2 sticky top-[68px] z-10 bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-lg">
      <div className="flex border-b border-black/10 dark:border-white/10 px-4 justify-between">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center justify-center border-b-[3px] pb-[13px] pt-2 flex-1 gap-1 ${
              activeTab === tab.id
                ? 'border-b-primary'
                : 'border-b-transparent'
            }`}
          >
            <span className={`material-symbols-outlined !text-xl ${
              activeTab === tab.id ? 'text-primary' : 'text-content-light/50 dark:text-content-dark/50'
            }`}>
              {tab.icon}
            </span>
            <p className={`text-sm font-bold leading-normal tracking-[0.015em] ${
              activeTab === tab.id ? 'text-content-light dark:text-content-dark' : 'text-content-light/50 dark:text-content-dark/50'
            }`}>
              {tab.label}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}
